import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  visionNotif: {
    "& .MuiPopover-paper": {
      overflow: "hidden",
      width: 360,
      maxHeight: "100%",
    },
  },
  headerBtn: {
    padding: "2px",
    margin: "0 15px",
    [theme.breakpoints.down("xs")]: {
      margin: "0 8px",
      "& svg": {
        color: "#777",
      },
    },
  },
  readMessage: {
    background: "#F8F8F8",
    "& h6, p": {
      color: "#5E6066",
    },
  },
  visionBoardLink: {
    padding: "5px 16px",
    borderTop: "solid 1px #DBDBDB",
  },
  closeIcon: {
    color: "#CCCCCC",
  },
  thumbnail: {
    position: "relative",
    marginTop: 8,
    "& .react-thumbnail-generator": {
      "& img": {
        width: "100%",
        height: 110,
        objectFit: "cover",
        display: "block",
        borderRadius: 4,
      },
    },
  },
  playIcon: {
    position: "absolute",
    left: "50%",
    top: "50%",
    opacity: 0.75,
    marginLeft: "-16px",
    marginTop: "-16px",
    background: "#000",
    borderRadius: 50,
    width: 32,
    height: 32,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "& svg": {
      color: "#fff",
    },
  },
  popoverList: {
    cursor: "pointer",
    maxWidth: 360,
    padding: 0,
    "& li": {
      padding: "8px 16px",
      display: "flex",
      alignItems: "flex-start",
      "&:last-child": {
        border: "none",
      },
    },
  },
  selected: {
    background: theme.palette.secondary.main,
    border: "none !important",
    "&:hover": {
      background: theme.palette.secondary.main,
    },
    "& svg": {
      color: "#fff",
    },
  },
  buttonsLayout: {
    position: "relative",
    "& button": {
      padding: 0,
      height: 34,
      width: 34,
    },
  },
  notifAction: {
    "& svg": {
      width: 22,
    },
    "& button": {
      marginRight: 5,
    },
  },
  notifTitle: {
    boxShadow: "0px 1px 3px #00000029",
    padding: "5px 16px",
  },
  userName: {
    maxWidth: 80,
  },
  msgTitle: {
    maxWidth: "60%",
  },
  vertDivider: {
    color: "#DADADA",
  },
  clearBtn: (props) => {
    const txtColor =
      props.appTheme === "CLASSIC"
        ? theme.palette.primary.main
        : props.appTheme === "LIGHT"
        ? "#777"
        : theme.palette.primary.main;
    return {
      color: txtColor,
    };
  },
  reportIcon: {
    width: 36,
    height: 36,
    marginRight: 10,
    fontWeight: "normal",
    fontSize: 18,
    background: theme.palette.secondary.light,
    color: "red",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  mobileMenuName: {
    margin: "0 0 0 10px",
    paddingLeft: "5px",
    fontSize: 14,
  },
  visionImg: {
    width: "100%",
    height: 110,
    objectFit: "cover",
    borderRadius: 4,
    marginTop: 8,
  },
  notifPopover: {
    "& .MuiPopover-paper": {
      overflow: "hidden",
      width: 280,
    },
  },
  disableBtn: {
    color: "#CAC3C3 !important",
    pointerEvents: "none",
  },
}));
